import { useEffect, useState } from "react";

import { Layout } from "../components/layout";
import { OfferDetails } from "../components/offer-details";
import { OfferPageProps } from "../types/vino-data-types";
import SEO from "../components/seo/seo";

import isEqual from "lodash.isequal";
import styled from "styled-components";
import { Box, Text } from "@vinomofo/components";
import vinoFetch from "../utils/vinoFetch";
import { ProductPreloader } from "../components/preloaders/ProductPreloader";

export const RotatedFooterWaggler = styled(Box)`
  transform: rotate(180deg);
`;

const SecretOfferPage = ({ pageContext }: OfferPageProps): JSX.Element => {
  const { offer } = pageContext;
  const [offerDetails, setOfferDetails] = useState(offer);
  const seoSubTitle = offerDetails?.isMixed
    ? " - Mixed Case"
    : offerDetails?.category &&
      offerDetails?.category.toLocaleLowerCase() !== "sparkling"
    ? ` - ${offerDetails?.category} Wine`
    : offerDetails?.category
    ? ` - ${offerDetails?.category} `
    : "";
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const isLoyaltyOffer =
    offerDetails?.tiersEligible?.length > 0 &&
    !offerDetails?.tiersEligible.some((tier) =>
      ["GUEST", "ALL"].includes(tier)
    );

  useEffect(() => {
    vinoFetch
      .get(`/api/refresh-offer?id=${offerDetails.id}`)
      .then((res) => {
        setRefresh(true);
        if (!isEqual(res.data.offer, offerDetails)) {
          setOfferDetails(res.data.offer);
        }
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [offer]);

  return (
    <Layout pathname={offerDetails?.route?.path}>
      <SEO
        title={`${offerDetails.title || offerDetails.name}${seoSubTitle}`}
        image={offerDetails.cardImage?.url || ""}
        type={"product"}
        description={offerDetails.shortDescription}
        pathname={offerDetails.route?.path || ""}
        robots={offerDetails.noIndex ? "noindex, nofollow" : "index, follow"}
      />

      {isLoyaltyOffer ? (
        <Box minHeight="20vh">
          {loading ? (
            <ProductPreloader />
          ) : error ? (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              py={[4, 5]}
              px={[3, 4]}
            >
              <Text variant="sm" textAlign="center">
                {error}
              </Text>
            </Box>
          ) : (
            <OfferDetails offer={offerDetails} refresh={refresh} />
          )}
        </Box>
      ) : (
        <OfferDetails offer={offerDetails} refresh={refresh} />
      )}
    </Layout>
  );
};

export default SecretOfferPage;
